import { type AcquisitionOffer, mapAllocationToOffer } from './useFrontDoorOffer';
export const useSupFixOffer = (skip = false) => {
  const offer: AcquisitionOffer | null = skip ? null : mapAllocationToOffer('standard');
  return {
    offer,
    slimBannerVariant: 'promo-dark',
    loading: false
  };
};